import { render, staticRenderFns } from "./report-section-card.vue?vue&type=template&id=7a73ce1e"
import script from "./report-section-card.vue?vue&type=script&lang=js"
export * from "./report-section-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports